import Modal from "./modal";

export default class AddCollaboratorModal extends Modal {
  constructor(companyId) {
    super("add-collaborator-modal");
    this.companyId = companyId;
    this.formFields = [
      {
        name: "id",
        varType: "int",
      },
      {
        name: "name",
        varType: "string",
        required: true,
      },
      {
        name: "email",
        varType: "string",
        required: true,
      },
      {
        name: "level",
        varType: "int",
        trigger: "change",
        required: true,
      },
    ];

    this.setupStakeholders().then(() => {
      this.setupForm();
      this.whenReady();
    });
  }

  setupStakeholders() {
    return new Promise((resolve, reject) => {
      peque
        .api("stakeholders", { company: this.companyId }, "get")
        .then((response) => {
          const $stakeholderNames =
            document.getElementById("stakeholders-name");
          this.stakeholders = {};

          response.result.list.forEach((entry) => {
            // dont show those who dont have email set
            if (entry.email === null || entry.email.length < 1) {
              return;
            }
            const el = document.createElement("option");
            el.innerText = entry.fullName;
            $stakeholderNames.appendChild(el);

            this.stakeholders[entry.fullName] = entry.email;
          });
          resolve();
        });
    });
  }

  setupForm() {
    this.$level = this.$form.querySelector('[name="level"]');
    this.$level.addEventListener("change", () => {
      this.onLevelChange(parseInt(this.$level.value));
    });

    const $name = this.$form.querySelector('[name="name"]');
    const $email = this.$form.querySelector('[name="email"]');
    $name.addEventListener("change", () => {
      const name = $name.value;

      if (typeof this.stakeholders[name] !== "undefined") {
        $email.value = this.stakeholders[name];
      }
    });
  }

  onLevelChange(level) {
    this.$form.querySelectorAll("[data-permissions]").forEach((el) => {
      if (level === parseInt(el.dataset.permissions)) {
        el.classList.remove("d-none");
      } else {
        el.classList.add("d-none");
      }
    });
  }

  validateAndSendForm() {
    this.enableSubmitButton(false);

    this.getFields(this.formFields)
      .then((data) => {
        data.company = this.companyId;

        peque
          .api("collaborators", data, "post")
          .then((response) => {
            location.reload();
          })
          .catch((error) => {
            this.enableSubmitButton(true);

            if (typeof error.field === "undefined") {
              throw error;
            }
            this.showErrorOnField(
              error.result,
              this.$form.querySelector('[name="' + error.field + '"]')
            );
          });
      })
      .catch((error) => {
        this.enableSubmitButton(true);

        if (typeof error.el === "undefined") {
          throw error;
        }
        this.showErrorOnField(error.message, error.el);
      });
  }
}
